import { Component, OnInit, AfterViewInit } from '@angular/core';
import { NaviService } from '../../services/navi.service';
import { RegisterService } from '../../services/register.service';

import { User } from '../../models/user';
import { BasicError, Error409 } from '../../models/error/error';
declare var $: any;


@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit, AfterViewInit {
  public loginUrl: String = 'login';

  public inpFirstName: String = '';
  public inpLastName: String = '';
  public inpEmail: String = '';
  public inpName: String = '';
  public inpSex: String = '';
  public inpPassword: String = '';
  public inpPasswordConf: String = '';

  public registeredSuccess: Boolean = false;
  public alertInfo: Boolean = false;
  public infoOutput: String = '';

  // Vars for Logo
  public imgLogo: String = 'assets/img/tinnituscare.png';
  public landingpageUrl: String = '/';


  constructor(private naviService: NaviService, private registerService: RegisterService) { }

  ngOnInit() {
  }

  ngAfterViewInit() {

    const self = this;
    const inputs = '#reg1, #reg2, #reg3, #reg4, #reg5, #reg6';

    $(document).ready(function () {
      $(inputs).on('keydown', function (e) {
        if (e.which === 13) {
          self.registerNewUser();
        }
      });
    });

  } // ngAfterView end

  public registerNewUser() {
    if (this.inpFirstName !== '' && this.inpLastName !== '' && this.inpEmail !== '' && this.inpName !== '' && this.inpSex !== '' &&
      this.inpPassword !== '' && this.inpPasswordConf !== '' && this.inpPassword === this.inpPasswordConf && this.inpPassword.length >= 8) {
      this.registerService.registerUser(this.inpFirstName, this.inpLastName, this.inpName, this.inpEmail, this.inpSex,
        this.inpPassword, this.inpPasswordConf).subscribe(data => {
          if (data instanceof BasicError) {
            console.log('Registration failed!');
            console.log(data);
            this.infoOutput = 'Es ist ein Fehler aufgetreten!';
            this.alertInfo = true;
            if (data instanceof Error409) {
              this.infoOutput = 'Die von Ihnen angegebene Email wurde bereits verwendet.';
              this.alertInfo = true;
            }
          } else {
            this.registeredSuccess = true;
            this.alertInfo = false;
          }
        });

    } else {
      if (this.inpFirstName === '' || this.inpLastName === '' || this.inpEmail === '' || this.inpName === '' || this.inpSex === '' ||
        this.inpPassword === '' || this.inpPasswordConf === '') {
        this.infoOutput = 'Bitte füllen Sie alle Felder aus!';
        this.alertInfo = true;
      } else if (this.inpPassword.length < 8) {
        this.infoOutput = 'Das Passwort muss mind. 8 Zeichen enthalten!';
        this.alertInfo = true;
      } else if (this.inpPassword !== this.inpPasswordConf) {
        this.infoOutput = 'Das Passwort und die Passwortwiederholung müssen übereinstimmen!';
        this.alertInfo = true;
      }
    }

  }

  public registerNewUserShort() {
    if (this.inpEmail !== '' && this.inpName !== '' && this.inpPassword !== '' && this.inpPasswordConf !== '' &&
      this.inpPassword === this.inpPasswordConf && this.inpPassword.length >= 8) {
      this.registerService.registerUserShort(this.inpName, this.inpEmail, this.inpPassword, this.inpPasswordConf).subscribe(data => {
        if (data instanceof BasicError) {
          console.log('Registration failed!');
          console.log(data);
          this.infoOutput = 'Es ist ein Fehler aufgetreten!';
          this.alertInfo = true;
          if (data instanceof Error409) {
            this.infoOutput = 'Die von Ihnen angegebene Email wurde bereits verwendet.';
            this.alertInfo = true;
          }
        } else {
          this.registeredSuccess = true;
          this.alertInfo = false;
        }
      });
    } else {
      if (this.inpFirstName === '' || this.inpLastName === '' || this.inpEmail === '' || this.inpName === '' || this.inpSex === '' ||
        this.inpPassword === '' || this.inpPasswordConf === '') {
        this.infoOutput = 'Bitte füllen Sie alle Felder aus!';
        this.alertInfo = true;
      } else if (this.inpPassword.length < 8) {
        this.infoOutput = 'Das Passwort muss mind. 8 Zeichen enthalten!';
        this.alertInfo = true;
      } else if (this.inpPassword !== this.inpPasswordConf) {
        this.infoOutput = 'Das Passwort und die Passwortwiederholung müssen übereinstimmen!';
        this.alertInfo = true;
      }
    }
  }

  public navigateToLogin() {
    this.naviService.navigateToUrl(this.loginUrl, 'login');
  }

  public navigateToLandingPage() {
    this.naviService.navigateToUrl(this.landingpageUrl, '');
  }
}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/registration/registration.component.ts